import React from 'react'

const SearchIconWhite = ({ width = 13, height = 13, opacity = 0.8 }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.0077 9.02158L12.3854 11.3924C12.5178 11.5237 12.5923 11.7024 12.5923 11.8889C12.5923 12.0754 12.5178 12.2541 12.3854 12.3854C12.2541 12.5178 12.0754 12.5923 11.8889 12.5923C11.7024 12.5923 11.5237 12.5178 11.3924 12.3854L9.02158 10.0077C8.04421 10.7748 6.83728 11.1911 5.59478 11.1896C2.50487 11.1896 0 8.68469 0 5.59478C0 2.50487 2.50487 0 5.59478 0C8.68469 0 11.1896 2.50487 11.1896 5.59478C11.1911 6.83728 10.7748 8.04421 10.0077 9.02158ZM5.59478 1.39869C3.27735 1.39869 1.39869 3.27735 1.39869 5.59478C1.39869 7.91221 3.27735 9.79086 5.59478 9.79086C7.91221 9.79086 9.79086 7.91221 9.79086 5.59478C9.79086 3.27735 7.91221 1.39869 5.59478 1.39869Z"
                fill="white"
                fillOpacity={opacity}
            />
        </svg>
    )
}

export default SearchIconWhite

